import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { DataService } from "../components/shared/services/data.service";
import { Tipo } from "../models/tipo";
import { Empresa } from "../models/empresa.model";
import { Observable } from "rxjs";
import { Indicacao } from "../models/indicacao.model";

@Injectable()
export class EmpresaService extends DataService {

  url = this.urlApi + 'v1/empresa/';

  constructor(private http: HttpClient) {
    super();
  }
  getAll(status: string, cnpj:string, razaoSocial:string, pagina: number, quantidade: number, idUnidade: string) {
    const params = new HttpParams()
      .set('pagina', pagina.toString())
      .set('quantidade', quantidade.toString())
      .set('status', status ? status : '')
      .set('razaoSocial', razaoSocial ? razaoSocial : '')
      .set('cnpj', cnpj ? cnpj : '')
      .set('idUnidade', idUnidade ? idUnidade : '');
    return this.http.get<Empresa[]>(this.url + 'all', {params: params})
      .catch(this.handleError);
  }
  
  inserirEmpresa(empresa: any) {
    return this.http.post(this.url + 'inserir', empresa)
      .catch(this.handleError);
  }
  updateEmpresa(empresa: any, usuario: string) {
      return this.http.post(this.url + 'atualizar/' + usuario, empresa)
        .catch(this.handleError);
    }
  getEmpresaById(idEmpresa: any) {
    return this.http.get(this.url + idEmpresa)
      .catch(this.handleError);
  }
//   editarEmpresa(empresa) {
//     return this.http.put(this.url + 'editar', empresa)
//       .catch(this.handleError);
//   }

  getListaTipoEmpresa() {
    return this.http.get<Tipo[]>(this.url + 'tipoEmpresa')
      .catch(this.handleError);
  }

  getListaTipoSetor() {
    return this.http.get<Tipo[]>(this.url + 'tipoSetor')
      .catch(this.handleError);
  }
  getSigopByCnpj(cnpj: string) {
    return this.http.get(this.url + 'sigopByCnpj/' + cnpj)
      .catch(this.handleError);
  }
  enviarEmails(empresaIds: string[], nomeRemetente: string) {
    return this.http.post(this.url + 'email/enviar', { empresaIds: empresaIds, usuarioRemetente: nomeRemetente })
    ._catch(this.handleError);
  }

  //Indicacao
  inserirIndicacao(indicacao: any) {
    return this.http.post(this.url + 'indicacao/inserir', indicacao)
      .catch(this.handleError);
  }
  updateIndicacao(indicacao: any, usuario: string) {
      return this.http.post(this.url + 'indicacao/atualizar', indicacao)
        .catch(this.handleError);
    }
    getIndicacaoById(idIndicacao: any) {
      return this.http.get(this.url + '/indicacao/byId/' + idIndicacao)
        .catch(this.handleError);
    }
  getIndicacaoByIdEmpresa(idEmpresa: any) {
    return this.http.get(this.url + '/indicacao/byIdEmpresa/' + idEmpresa)
      .catch(this.handleError);
  }
  getIndicacaoByAll(pesquisa: any, idEmpresa:any) {
    return this.http.post(this.url + '/indicacao/byAll', { dado : pesquisa, idEmpresa: idEmpresa })
      .catch(this.handleError);
  }
  removerIndicacaoById(idIndicacao: any) {
    return this.http.delete(this.url + '/indicacao/remover/byId/' + idIndicacao)
      .catch(this.handleError);
  }
  removerIndicacaoByIdEmpresa(idEmpresa: any) {
    return this.http.delete(this.url + '/indicacao/remover/byIdEmpresa/' + idEmpresa)
      .catch(this.handleError);
  }
  removerIndicacaoByCpf(cpf: any) {
    return this.http.delete(this.url + '/indicacao/remover/byCpf/' + cpf)
      .catch(this.handleError);
  }

  realizarLogin(email :string, senha :string): Observable<Empresa> {
    return this.http.post(this.url + 'login', { Email: email, Senha: senha })
    ._catch(this.handleError);
  }

  recuperarSenha(email :string): Observable<boolean> {
    return this.http.post(this.url + 'recuperar-senha', { Email: email })
    ._catch(this.handleError);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/empresa.service.ts